import { useContext } from "react";
import { TrackingContext } from "./TrackingContext.js";
const useTrackingContext = ()=>{
    const context = useContext(TrackingContext);
    if (void 0 === context) throw new Error('useTrackingContext must be used withing an TrackingProvider');
    return context;
};
const TrackingContext_useTrackingContext = useTrackingContext;
export default TrackingContext_useTrackingContext;
export { useTrackingContext };
